import withLoader from "../../components/layouts/WithLoader";
import { useEffect, useState } from "react";

import 'react-big-calendar/lib/css/react-big-calendar.css';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import Banque from "../../services/Banque";

const localizer = momentLocalizer(moment);


const CustomToolbar = ({ label, onNavigate }) => {
  return (
    <div className="rbc-toolbar">
      {/* Navigation Buttons */}
      <div className="btn-group">
        <button
          type="button"
          className="btn btn-light"
          onClick={() => onNavigate('PREV')}
        >
          ‹ Previous
        </button>
        {/* <button
          type="button"
          className="btn btn-light mx-1"
          onClick={() => onNavigate('TODAY')}
        >
          Today
        </button> */}
        <button
          type="button"
          className="btn btn-light"
          onClick={() => onNavigate('NEXT')}
        >
          Next ›
        </button>
      </div>

      {/* Month/Year Label (Centered) */}
      <div className="rbc-toolbar-label">
        <h4 className="mb-0">{label}</h4>
      </div>
    </div>
  );
};


const PayementsAgenda = ({ startLoading, stopLoading }) => {
    const [selectedDate, setSelectedDate] = useState(new Date());
    const [banqueAccountInfo, setBanqueAccountInfo] = useState();
    const [achat, setAchat] = useState(0);
    const [vente, setVente] = useState(0);
    const [events, setEvents] = useState([]);
    useEffect(() => {
        startLoading();
        Banque.getBankAccountInfo(sessionStorage.getItem("idBankAccount"))
            .then((response) => {
                console.log(response);
                if (response.data.success) {
                    setBanqueAccountInfo(response.data.success);
                }
            })
            .catch(() => {
                console.log("error");
            }).finally(() => {
                stopLoading();
            });
    }, [])

    useEffect(() => {
        setAchat(0);
                setVente(0);
        const startDate = moment(selectedDate).startOf('month').toISOString();
        const endDate = moment(selectedDate).endOf('month').toISOString();

        console.log("startDate", startDate)
        console.log("endDate", endDate)


        startLoading();
        Banque.getEcheance(sessionStorage.getItem("idBankAccount"), startDate, endDate).then((response) => {

            if (response.data.success) {
                setEvents(response.data.success);

                setAchat(response.data.achat);
                setVente(response.data.vente);
            }
        }).catch((error) => { }).finally(() => {
            stopLoading();
        });

    }, [selectedDate])

    const ColoredEvent = ({ event }) => (
        <div style={{ backgroundColor: event.backgroundColor, borderRadius: '5px', padding: '2px' }} >
            {event.title}
        </div>
    );
    const handleSelectEvent = (event, e) => {
        console.log("handleSelectEvent", event)
        alert(event.description);
    };

    return (
        <div class="content-wrapper" style={{ marginTop: "0" }}>
            <section class="content">
                <div class="row">
                    <div class="col-md-12">
                        <div class="card  mt-3">
                            <div class="card-body">
                                <h4 class="card-title">Le Compte </h4>
                                <br />
                                <br />
                                {banqueAccountInfo && (
                                    <>
                                        <p> RIB :{banqueAccountInfo.rib}</p>
                                        <p>Compte :{banqueAccountInfo.name}</p>
                                        <p>Adresse :{banqueAccountInfo.agenceLocalisation}</p>
                                    </>
                                )
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section class="content">

                <div className="row">
                    <div className=" col-md-4"></div>
                    <div className="info-box bg-success col-md-2 col-sm-5 col-12 m-2">
                        <span className="info-box-icon">
                            <i class="fas fa-money-bill"></i>

                        </span>
                        <div className="info-box-content">
                            <span className="info-box-text">Vente</span>
                            <span className="info-box-number">{vente}</span>
                            <div className="progress">
                                <div className="progress-bar" style={{ width: "70%" }}></div>
                            </div>

                        </div>
                    </div>

                    <div className="info-box bg-danger col-md-2 col-sm-5 col-12 m-2">
                        <span className="info-box-icon">
                            <i class="fas fa-money-bill"></i>
                        </span>
                        <div className="info-box-content">
                            <span className="info-box-text">Achat</span>
                            <span className="info-box-number">{achat}</span>
                            <div className="progress">
                                <div className="progress-bar" style={{ width: "70%" }}></div>
                            </div>
                        </div>
                    </div>
                </div>


            </section>
            <section class="content">
                <div class="row">
                    <div class="col-md-12">
                        <div className="card ">
                            <div className="card-body">
                                <Calendar
                                    localizer={localizer}
                                    events={events}
                                    startAccessor="start"
                                    endAccessor="end"
                                    defaultDate={selectedDate}
                                    views={['month', 'agenda']}
                                    style={{ height: 500 }}
                                    components={{
                                        toolbar: CustomToolbar,
                                        eventWrapper: ColoredEvent,
                                    }}
                                    onNavigate={(date, view) => {
                                        if (view === 'month') {
                                            setSelectedDate(date);
                                        }
                                    }}
                                    popup
                                />

                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default withLoader(PayementsAgenda);
